import React from 'react';
import styled from 'styled-components';

import Checkmark from 'src/svg/checkmark';

export default function DropdownOption(props) {
  const { onSelect, option, selected } = props;

  function handleSelect(event) {
    event.preventDefault();
    if (option.disabled) {
      return;
    }

    onSelect(option);
  }

  return (
    <Container onMouseDown={handleSelect} selected={selected} value={option.value} disabled={option.disabled}>
      <Text noWrap={option.noWrap}>{option.label}</Text>

      {selected && (
        <Icon>
          <Checkmark color='#a7aeb5' />
        </Icon>
      )}
    </Container>
  );
}

const Container = styled.div`
  border-radius: 4px;
  color: ${({ disabled }) => (disabled ? '#9ea7ab' : '#707478')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  padding: 12px 56px 12px 24px;

  :focus,
  :hover {
    background-color: ${({ disabled }) => (disabled ? 'none' : '#f6f6f6')};
  }
`;

const Text = styled.span`
  flex: 1 0 0%;
  min-width: 0;
  white-space: ${({ noWrap }) => (noWrap ? 'nowrap' : 'unset')};
`;

const Icon = styled.span`
  flex: 0 0 auto;
  margin-right: -44px;
  padding-left: 4px;
`;
